<ng-template pTemplate="header">
  <span class="text-xl font-bold">{{ question_title }}</span>
</ng-template>
<label>Nome*</label>
<input
  type="text"
  [formControl]="value"
  class="w-full mb-3"
  pInputText />
<label>Iva*</label>
<p-dropdown
  placeholder="Seleziona..."
  [options]="iva"
  optionLabel="label"
  optionValue="id"
  [formControl]="selectedIva"
  styleClass="w-full mb-3"
  [emptyMessage]="'Nessun risultato trovato'"
  appendTo="body">
</p-dropdown>
<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      (onClick)="close()"
      label="Annulla"
      [text]="true"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      [label]="button_ok_title"
      (onClick)="save()"
      styleClass="butt"
      [rounded]="true"
      [disabled]="!value.valid || !selectedIva.valid"></p-button>
  </div>
</div>
